import { AddAnimals } from './add-animals';

export * from './add-animals';

export default AddAnimals;
